export default __webpack_public_path__ + "static/media/248.b79fc4e2.jpg";